import { Routes } from '@angular/router';
import { provideCourseStore } from '@app/store/course';
import { provideFormOptionsStore } from '@app/store/form-options';
import { provideAssessmentStore } from '@app/store/assessment';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const coursesModalRoutes: Routes = [
    {
        path: 'courses/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideCourseStore(), ...provideFormOptionsStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'courses/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideCourseStore(), ...provideAssessmentStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'courses/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideCourseStore(), ...provideFormOptionsStore(), ...provideAssessmentStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
